/* @flow */

import { textColor } from '@e180/ui/lib/token/color';
import { blueGrey } from '@e180/ui/lib/token/palette';

export default {
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  circle: {
    display: 'inline-block',

    width: 22,
    height: 22,
    marginRight: '1.14286rem',

    border: '1px solid',
    borderRadius: '50%',
    backgroundColor: blueGrey,

    cursor: 'pointer',
  },
  label: {
    margin: '8px 0',

    color: textColor,

    fontWeight: 500,
  },
};
